import { useState } from "react";
import { useCities } from "@/lib/data";

export default function LocationPicker({ city, neighborhood, onChange, prefix = "loc" }) {
  const { data: cities = [] } = useCities();
  const current = cities.find((c) => c.name === city);
  const known = current?.neighborhoods?.map((n) => n.name) || [];
  const [other, setOther] = useState(!!neighborhood && !!current && !known.includes(neighborhood));

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div>
        <label className="po-label" htmlFor={`${prefix}-city`}>Cidade</label>
        <select id={`${prefix}-city`} className="po-select" value={city || ""} data-testid={`${prefix}-city-select`}
          onChange={(e) => { setOther(false); onChange({ city: e.target.value, neighborhood: "" }); }}>
          <option value="">Escolha a cidade</option>
          {cities.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
        </select>
      </div>
      <div>
        <label className="po-label" htmlFor={`${prefix}-nb`}>Bairro</label>
        {!other ? (
          <select id={`${prefix}-nb`} className="po-select" value={neighborhood || ""} disabled={!city} data-testid={`${prefix}-neighborhood-select`}
            onChange={(e) => {
              if (e.target.value === "__other") { setOther(true); onChange({ city, neighborhood: "" }); }
              else onChange({ city, neighborhood: e.target.value });
            }}>
            <option value="">Escolha o bairro</option>
            {known.map((n) => <option key={n} value={n}>{n}</option>)}
            <option value="__other">Outro bairro (digitar)</option>
          </select>
        ) : (
          <input id={`${prefix}-nb`} className="po-input" placeholder="Digite o nome do bairro" value={neighborhood || ""}
            data-testid={`${prefix}-neighborhood-input`} onChange={(e) => onChange({ city, neighborhood: e.target.value })} />
        )}
      </div>
    </div>
  );
}
